import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDc50IbG6YEQOwfJve3V3-xwo5JbDpDyUg",
  authDomain: "clone-24aee.firebaseapp.com",
  projectId: "clone-24aee",
  storageBucket: "clone-24aee.appspot.com",
  messagingSenderId: "607206889907",
  appId: "1:607206889907:web:b3db5ca144053cd57513c6",
  measurementId: "G-S0X11P4TF7",
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore();
const auth = getAuth();

export { db, auth };
